import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Check, Times, isOpen } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { IsOpen } from '../../../components/Icon';
import { selectWork, selectWorks, selectPermissions } from '../../Api/selectors';
import { DocumentsList } from '../../Documents/components/documentsList';
import { deleteVehicleProperty, setVehicleProperty } from '../actions';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { ButtonBar } from '../../../components/ButtonBar';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import cn from 'classnames';
import styles from './CardWebsite.module.css';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { hasPermissions } from '../../../utils/helpers/permissions';





let todaydate = new Date().toISOString();

const Container = styled.div`
  .button.inactive {
    opacity: 0.4;
  }
`;

const STATE = {
  isOpen: false,  
};  
  
 
/* eslint-disable react/prefer-stateless-function */
class VehicleWebsiteCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {

    if (hasPermissions(this.props.permissions, DEP_COMMERCE )) {
      this.setState({ isOpen: true });
    }
  }

  render() {
    const vehicle = this.props.vehicle;
    console.log(vehicle.show_on_sales_website);
    if (this.props.works) return <LoadingDetailsPageCard />;

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
        <HBox vCenter left>  
          <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.website.title')}</h2>
          <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>  
                <IsOpen />  
              </div> 
         </HBox>
         {this.state.isOpen && (   <>    
         <p>{this.lbl('vehicle.info.website.view')}</p>

          <ButtonBar className="mt-2">
            <Button
              onClick={() => this.props.setValue('1')}
              small
              className={cn(vehicle.show_on_sales_website != '1' ? 'inactive' : '', styles.buttonVisible)}
            >
              {vehicle.show_on_sales_website ? <Check /> : null}
              {this.lbl('vehicle.info.website.visible')}
            </Button>
            <Button
              onClick={() => this.props.setValue('0')}
              small
              className={cn(vehicle.show_on_sales_website == '1' ? 'inactive' : '', styles.buttonNotvisible)}
            >
              {!vehicle.show_on_sales_website ? <Times /> : null}
              {this.lbl('vehicle.info.website.notvisible')}
            </Button>
          </ButtonBar>

          <p style={{marginTop:'10px'}}>{this.lbl('vehicle.info.website.view_inspection')}</p>
          <ButtonBar className="mt-2">
            <Button
              onClick={() => this.props.setValueInspection('1')}
              small
              className={cn(vehicle.show_inspection_on_sales_website != '1' ? 'inactive' : '', styles.buttonVisible)}
            >
              {vehicle.show_inspection_on_sales_website ? <Check /> : null}
              {this.lbl('vehicle.info.website.inspection_visible')}
            </Button>
            <Button
              onClick={() => this.props.setValueInspection('0')}
              small
              className={cn(vehicle.show_inspection_on_sales_website == '1' ? 'inactive' : '', styles.buttonNotvisible)}
            >
              {!vehicle.show_inspection_on_sales_website ? <Times /> : null}
              {this.lbl('vehicle.info.website.inspection_notvisible')}
            </Button>
          </ButtonBar>
          </>)}
        </Container>
      </Card>
    );
  }
}

VehicleWebsiteCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    works: selectWorks([`${REQUEST_VEHICLE_PROPERTY_UPDATE}-show_on_sales_website`, REQUEST_VEHICLE]),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    unsetValue() {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'show_on_sales_website'));
    },
    setValue(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'show_on_sales_website', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'show_on_sales_website_date', todaydate));
    },
    unsetValueInspection() {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'show_inspection_on_sales_website'));
    },
    setValueInspection(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'show_inspection_on_sales_website', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'show_inspection_on_sales_website_date', todaydate));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleWebsiteCard = compose(withConnect, withRouter)(VehicleWebsiteCardComp);
